import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import InquiryService from "../services/inquiryService";
import { FaqCard } from "./FaqCard";
import { Swiper, SwiperSlide } from "swiper/react";

interface Category {
  lable: string;
  value: string;
}

const FrequentlyAskedQuestions: React.FC = () => {
  const { t } = useTranslation();
  const categories: Category[] = [
    { lable: t("Big Pass"), value: "PASS" },
    { lable: t("Ticket"), value: "TICKET" },
    { lable: t("Tour"), value: "TOUR" },
    { lable: t("Musical"), value: "MUSICAL" },
    { lable: t("E-sim"), value: "SIM" },
  ];
  const [selectedCategory, setSelectedCategory] = useState<string>(
    categories[0].value || "",
  );

  const {
    data: faqs,
    isLoading,
    isError,
  } = useQuery<any[]>({
    queryKey: ["faq", selectedCategory],
    queryFn: async () => {
      const response = await InquiryService.getFAQ(selectedCategory);
      if (!response) {
        throw new Error("No data");
      }
      return response;
    },
  });

  const handleCategoryClick = (category: string) => {
    setSelectedCategory(category);
  };

  const renderCategory = () => (
    <Swiper slidesPerView={"auto"} spaceBetween={12} className="my-8">
      {categories.map((category) => (
        <SwiperSlide className="max-w-fit" key={category.value}>
          <button
            key={category.value}
            className={`rounded-[3.125rem] px-[1.0625rem] py-2 text-[0.875rem] font-normal leading-[1.25rem] ${
              selectedCategory === category.value
                ? "bg-black font-semibold text-white"
                : "border border-[#EAEEF3] bg-white"
            }`}
            onClick={() => handleCategoryClick(category.value)}
          >
            {category.lable}
          </button>
        </SwiperSlide>
      ))}
    </Swiper>
  );

  const renderSchedule = () => {
    if (isLoading) {
      return null;
    }
    if (isError || !faqs || faqs.length === 0) {
      return <p>{t("No data")}</p>;
    }
    return (
      <div className="mt-[2.625rem] grid grid-rows-1 gap-5 sm:grid-cols-2">
        <div className="flex flex-col gap-[1.875rem]">
          {faqs
            ?.filter((_, index) => index % 2 === 0)
            .map((faq, index) => <FaqCard key={index} {...faq} />)}
        </div>
        <div className="flex flex-col gap-[1.875rem]">
          {faqs
            ?.filter((faq, index) => index % 2 === 1)
            .map((faq, index) => <FaqCard key={index} {...faq} />)}
        </div>
      </div>
    );
  };

  return (
    <div className="mb-[4.75rem]">
      {renderCategory()}
      {renderSchedule()}
    </div>
  );
};

export default FrequentlyAskedQuestions;
